const LETTERS = ["a", "b", "c", "d"];

export function keyToOptionIndex(key: string, optionCount: number): number | null {
  const byNumber = Number.parseInt(key, 10);
  if (Number.isInteger(byNumber) && byNumber >= 1 && byNumber <= optionCount) {
    return byNumber - 1;
  }

  const byLetter = LETTERS.indexOf(key.toLowerCase());
  if (byLetter >= 0 && byLetter < optionCount) return byLetter;
  return null;
}

export function isAdvanceKey(key: string): boolean {
  return key === "Enter" || key === " ";
}
